export default __webpack_public_path__ + "static/media/C2_10_x_15.a02dd0dc.jpg";